<style scoped lang="less">
	.search-box{
        margin-bottom: 20px;
    }
    .table-box{
        margin-bottom: 15px;
    }
	
	.shop-name{
		display: flex;
	}
	.shop-name .img{
		flex: 0 0 auto;
	}
	.shop-name .name{
		flex: 1 1 auto;
		overflow: hidden;
		display: flex;
		align-items: center;
	}
</style>
<template>
	<el-dialog :visible="show" :append-to-body="true" width='820px' title="选择直播间分组" @close="cancel">

		<!-- <div class="search-box filter-container">
			<div class="filter-item">
				<span style="padding-right: 10px;">关键字：</span>
				<el-input v-model="keywords" style="width:200px;margin-right:10px" size="mini" placeholder="商品名称、编码" />
			</div>

			<div class="filter-item">
				<el-button type="primary" size="mini" @click="search">搜索</el-button>
			</div>
		</div> -->

		<div class="table-box">
			<el-table :data="data" v-loading="loading" size="mini" :row-key="getRowKey" ref="tab" @selection-change="handleSelectionChange">
				<el-table-column type="selection" width="55" :reserve-selection="true"></el-table-column>
				<el-table-column label="分组名称" prop="GroupName" width="560px"></el-table-column>
				<el-table-column label="关联直播间数量" prop="LiveRoomCount" width="160px"></el-table-column>
			</el-table>
		</div>

		<el-pagination :current-page="pageIndex" :total="total" :page-size="pageSize" @current-change="pageChange"></el-pagination>

		<div slot="footer">
			<el-button type="primary" @click="btnSure">确定</el-button>
		</div>

	</el-dialog>
</template>
<script>
	import {
		editSelectLiveRoomByGroup
	} from '../../api/pageManage.js';
	
	import config from '@/config/index'
	export default {
		components: {

		},
		props: {
			visible: {
				type: Boolean,
				default: false
			},
			isSingle: { //是否是单选
				type: Boolean,
				default: false
			},
			selectedList: {
				type: Array,
				default: () => {
					return []
				}
			},
			activityId: {
				type: Number,
				default: 0
			}
		},
		data() {
			return {
				keywords: '',
				pageIndex: 1,
				pageSize: 5,
				total: 0,
				loading: false,
				selectedData: [],
				singleData: {},
				data: [],
				show: false,
				imgUrl: config.IMG_BASE
			};
		},
		methods: {
			
			async getData() {
				const params = {
					Keywords: this.keywords,
					Skip: (this.pageIndex-1)*this.pageSize,
					Take: this.pageSize
				}

				this.loading = true;

				const res = await editSelectLiveRoomByGroup(params);

				this.loading = false;
				this.total = res.Result.Total;
				this.data = res.Result.Results;

				if (!this.isReady) {
					console.log(this.selectedList)
					if (this.$refs['tab']) {
						this.$refs['tab'].clearSelection()
						this.selectedList.map(item => {
							if (item.Id){
								this.$refs['tab'].toggleRowSelection(item, true);
							}
						})
						this.isReady = true;
					}
				}

			},
			getRowKey(row) {
				return row.Id
			},
			cancel() {
				this.$emit('cancel');
			},
			pageChange(value) {
				this.pageIndex = value;
				this.getData();
			},
			search() {
				this.pageIndex = 1;
				this.getData();
			},
			//当前页全选
			handleSelectionChange(val) {
				this.selectedData = val;
			},
			selectedRow(record, row) {
				this.singleData = row;
			},
			btnSure() {
				// if (this.isSingle && this.selectedData.length > this.disableList.length+1){
				//     this.$Message.error('修改产品只能单选！');
				//     return;
				// }

				this.$emit('change', this.selectedData);
				this.cancel();
			}
		},
		watch: {
			visible(value) {
				this.show = value;

				if (value) {
					console.log(this.selectedList)
					if (this.$refs['tab']) {
						this.$refs['tab'].clearSelection()
						this.selectedList.map(item => {
							if (item.Id){
								this.$refs['tab'].toggleRowSelection(item, true);
							}
						})
					}

					this.getData();

				}
			}
		},
		mounted() {
			// this.selectedList.map(item => {
			// 	this.$refs['tab'].toggleRowSelection(item, true);
			// })
			//this.getData();
		},
		created() {

		},
		dispatch() {

		}
	};
</script>
